/**
 * ProtectedRoute Component
 *
 * DEPRECATED: Authentication is now handled server-side by middleware.
 * This component is kept for backwards compatibility but simply renders children.
 * Middleware handles all auth checks and redirects.
 */

'use client'

import React from 'react'

interface ProtectedRouteProps {
  children: React.ReactNode
  fallback?: React.ReactNode
  redirectTo?: string
  allowedRoles?: string[]
  onUnauthorized?: () => void
}

export function ProtectedRoute({
  children,
}: ProtectedRouteProps) {
  // Server-side middleware handles all authentication
  // Simply render children
  return <>{children}</>
}

/**
 * Higher-order component version for page components
 */
export function withProtectedRoute<P extends object>(
  Component: React.ComponentType<P>,
  options?: Omit<ProtectedRouteProps, 'children'>
) {
  return function ProtectedComponent(props: P) {
    return (
      <ProtectedRoute {...options}>
        <Component {...props} />
      </ProtectedRoute>
    )
  }
}